import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  inject
} from "@angular/core";
import { compact } from "lodash-es";
import {
  ReportDesignerItemGroupHorizontal,
  ReportDesignerItemGroupHorizontalConfig
} from "src/app/modules/bootstrap/modules/report/report-design-item";
import { ReportDesignerComponent } from "src/app/modules/bootstrap/modules/report/report-designer/report-designer.component";

@Component({
  standalone: false,
  selector: "snt-report-designer-group-horizontal",
  templateUrl: "report-designer-group-horizontal.component.html",
  styles: `
    :host {
      display: flex;
      flex: 1;
    }
  `
})
export class ReportDesignerGroupHorizontalComponent implements OnInit {
  @Input()
  item!: ReportDesignerItemGroupHorizontal;

  @Input()
  templateOutlet!: TemplateRef<any>;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readonly: boolean = false;

  @Output()
  config: EventEmitter<ReportDesignerItemGroupHorizontalConfig> =
    new EventEmitter();

  formData = {
    title: ""
  };

  private _collapsed: boolean = false;

  get collapsed() {
    return this._collapsed;
  }

  set collapsed(value: boolean) {
    this._collapsed = value;
    this.item.childTitle = value ? this.formData.title : undefined;
  }

  private readonly reportDesigner = inject(ReportDesignerComponent);

  ngOnInit(): void {
    this.formData.title = this.item.config.title || "";
  }

  onFieldDataChanged(): void {
    this.item.config = {
      ...this.item.config,
      ...this.formData
    };

    this.config.emit(this.item.config);
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    const allRenderers = this.reportDesigner.renderers.toArray();
    const filteredRenderers = allRenderers.filter(
      (x) =>
        x.level === this.level + 1 && x.parentGroup === this.item.config.name
    );

    return {
      type: "group-horizontal",
      config: {
        title: this.item.config.title,
        items: compact(
          await Promise.all(
            filteredRenderers.map((x) =>
              !!x.renderPdfObject ? x.renderPdfObject() : Promise.resolve(null)
            )
          )
        )
      }
    };
  }
}
